/* Ron Tomson native color swatches.
   Phase 2: reads the current product's `custom.style_number` metafield (emitted
   by snippets/rt-color-swatches.liquid as data-rt-style-number) and fetches
   sibling color products via Shopify predictive search filtered by `sku: <N>` tag.
   No dependency on Platmart's pl_swatches.groups derived metafield.

   Standardizes the Color UL across PDPs to ALWAYS show portrait product thumbnails:
   - Replaces the native <i class="icon-circle"> color-circle (theme's check.color
     style) with the current product's image, so every color looks the same.
   - Appends sibling-color products as additional <li> entries with the same markup
     so navigation between colors is one consistent row.
*/
(function () {
  if (window.__rtSwatchesLoaded) return;
  window.__rtSwatchesLoaded = true;

  var dataEl = document.querySelector('[data-rt-swatch-data]');
  if (!dataEl) return;
  var currentHandle = dataEl.getAttribute('data-rt-current-handle');
  var styleNumber = dataEl.getAttribute('data-rt-style-number');
  if (!styleNumber) return;

  // Preserve preview-theme params on sibling links so navigating in draft preview stays in preview.
  var preserveParams = '';
  try {
    var u = new URL(location.href);
    var keep = ['preview_theme_id', 'skipCache', '_fd', 'pb'];
    var carried = new URLSearchParams();
    keep.forEach(function (k) {
      var v = u.searchParams.get(k);
      if (v !== null) carried.set(k, v);
    });
    var s = carried.toString();
    if (s) preserveParams = '?' + s;
  } catch (e) {}

  function deriveColorName(title) {
    // Convention: "Garment Name - Color"
    if (!title) return '';
    var idx = title.lastIndexOf(' - ');
    return idx >= 0 ? title.slice(idx + 3).trim() : title;
  }

  function buildSwatchInner(name, imgUrl) {
    var safeName = (name || '').replace(/"/g, '&quot;');
    return '<span class="img img-multiply-bg">' +
      (imgUrl ? '<img src="' + imgUrl + '" alt="' + safeName + '" width="50" height="70" loading="lazy" decoding="async">' : '') +
      '</span>';
  }

  function injectSwatches(siblings, currentSwatch) {
    var allULs = document.querySelectorAll('.f8pr-variant-selection ul.check');
    var injected = 0;
    for (var i = 0; i < allULs.length; i++) {
      var colorUL = allULs[i];
      if (colorUL.closest && colorUL.closest('dialog,[class*="quick"],[class*="drawer"],[class*="modal"],[class*="popup"],[id*="quick"],[id*="Drawer"]')) continue; // rt-fix 2026-07-11: no page-product swatches in quick-shop
      var firstInput = colorUL.querySelector('input[type="radio"]');
      var optName = firstInput && firstInput.name ? firstInput.name : '';
      if (!/-Color\]$/i.test(optName)) continue;
      if (colorUL.dataset.rtSiblingsInjected === '1') continue;
      colorUL.dataset.rtSiblingsInjected = '1';
      colorUL.classList.add('rt-color-uniformized');

      // 1. Standardize the native (current) LI: replace icon-circle/whatever with the
      //    current product's image so it matches sibling thumbnails.
      if (currentSwatch && currentSwatch.image) {
        var nativeLabel = colorUL.querySelector('li:not(.rt-sibling-color) > label');
        if (nativeLabel) {
          nativeLabel.innerHTML = buildSwatchInner(currentSwatch.name || '', currentSwatch.image);
        }
      }

      // 2. Append sibling LIs (skip current — it's the native radio LI we just standardized)
      var frag = document.createDocumentFragment();
      siblings.forEach(function (s) {
        if (!s || !s.handle || s.handle === currentHandle) return;
        var li = document.createElement('li');
        li.className = 'rt-sibling-color';
        var safeName = (s.name || '').replace(/"/g, '&quot;');
        li.innerHTML =
          '<a href="/products/' + s.handle + preserveParams + '" ' +
            'title="' + safeName + '" ' +
            'aria-label="' + safeName + '"' +
            (s.out_of_stock ? ' data-rt-oos="1"' : '') + '>' +
            buildSwatchInner(s.name || '', s.image || '') +
          '</a>';
        frag.appendChild(li);
      });
      if (frag.childNodes.length > 0) {
        colorUL.appendChild(frag);
        injected++;
      }
    }
    return injected;
  }

  function fetchAndRender() {
    // Prefer the pre-started promise from the snippet (fires during body parse).
    // Fall back to fresh fetch if promise isn't there for any reason.
    var promise = window.__rtSwatchPromise;
    if (!promise) {
      var q = 'tag:"sku: ' + styleNumber + '"';
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product' +
                '&resources[limit]=20' +
                '&resources[options][unavailable_products]=last';
      promise = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }
    promise
      .then(function (j) {
        var products = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        if (!products.length) return;

        // Map to swatch shape; find the current product in the list to use as the "active" thumbnail.
        var swatches = products.map(function (p) {
          return {
            handle: p.handle,
            name: deriveColorName(p.title),
            image: p.image || (p.featured_image && p.featured_image.url) || '',
            out_of_stock: (p.available === false)
          };
        });
        var currentSwatch = null;
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].handle === currentHandle) { currentSwatch = swatches[i]; break; }
        }
        injectSwatches(swatches, currentSwatch);

        // Defensive retry once for late-rendered variant blocks
        setTimeout(function () { injectSwatches(swatches, currentSwatch); }, 800);
      })
      .catch(function (e) {
        // Silently no-op on fetch failure — page still works without sibling swatches
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndRender);
  } else {
    fetchAndRender();
  }
})();
